export default "__VITE_ASSET__9RtiWt6h__";